export const applicationTypeConstants = {
  learner: "LEARNER",
  teacher: "TEACHER",
  supervisor: "SUPERVISOR",
};

export const userTypeConstants = {
  student: "STUDENT",
};
